<template>
  <div>
    <van-nav-bar :title="title" :right-text="rightText" left-arrow @click-left="onClickLeft" @click-right="onClickRight" />
  </div>
</template>

<script>
export default {
  props: ['title', 'rightText'],
  data() {
    return {}
  },
  created() {},
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push({
        path: '/home'
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
